import { IconUpload } from "@/app/_components/icons";
import { ImageAcceptType } from "@/services/constants/global";
import { getFileType } from "@/services/utils/general";
import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  HStack,
  IconButton,
  Image,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";

export default function MultipleFileUploadInput({
  name = "",
  maxFiles = 3,
  title = null,
  customThumb = null,
  accept = ImageAcceptType,
  onRemoveFileClick = () => {},
  values = [],
  isDisabled = false,
  onUpload = () => {},
  defaultImage,
  ...props
}) {
  const { t } = useTranslation();
  const uploadIsDisabled = isDisabled || values.length >= maxFiles;

  const parsedValues = values.map((item) => {
    item.itemName = decodeURIComponent(
      get(item, "name") || get(item, "originalName")
    );
    item.imageUrl = get(item, "url") || URL.createObjectURL(item);
    return item;
  });

  const handleChange = (event) => {
    if (!event.target.files[0]) return;
    const _newFiles = [...values, ...event.target.files].slice(0, maxFiles);
    onUpload(name, _newFiles);
    event.target.value = null;
  };

  return (
    <Stack>
      <Box
        borderWidth="1px"
        borderColor="rgba(73, 166, 252, 0.20)"
        borderStyle="dashed"
        rounded="md"
        bgColor="#F6F7FB"
        mt={6}
        {...props}
      >
        <Box position="relative" h="full" w="full" py={2} cursor="pointer">
          {customThumb || (
            <HStack justifyContent="center" color="secondary">
              <IconUpload />
              <Text>{title || t("File upload")}</Text>
            </HStack>
          )}
          <Input
            cursor={uploadIsDisabled ? "not-allowed" : "pointer"}
            type="file"
            position="absolute"
            w="full"
            h="full"
            aria-hidden="true"
            opacity={0}
            top={0}
            left={0}
            isDisabled={uploadIsDisabled}
            _disabled={{
              opacity: 0,
            }}
            multiple
            onChange={handleChange}
            accept={accept}
          />
        </Box>
      </Box>
      {get(parsedValues, "length") &&
        parsedValues.map((item, index) => (
          <HStack
            key={JSON.stringify(item)}
            py={2}
            px={4}
            bgColor="#F6F7FB"
            rounded="md"
            justifyContent="space-between"
          >
            <HStack flexGrow={1} justifyContent="space-between">
              <HStack>
                {ImageAcceptType.includes(
                  getFileType(get(item, "itemName"))
                ) && (
                  <Image
                    w={6}
                    h={6}
                    src={get(item, "imageUrl")}
                    alt="Image thumb"
                  />
                )}
                <Text fontSize={{ base: 14, md: 16 }}>
                  {get(item, "itemName")}
                </Text>
              </HStack>
              <Text fontSize="xs" whiteSpace="nowrap">
                {(get(item, "size") / 1024 / 1024).toFixed(2)} MB
              </Text>
            </HStack>
            <IconButton
              onClick={() => onRemoveFileClick(index)}
              icon={<CloseIcon />}
              variant="ghost"
              isDisabled={isDisabled}
            />
          </HStack>
        ))}
      {defaultImage && !get(parsedValues, "length") && (
        <HStack
          py={2}
          px={4}
          bgColor="#F6F7FB"
          rounded="md"
          justifyContent="space-between"
        >
          <HStack flexGrow={1} justifyContent="space-between">
            <HStack>
              <Image w={6} h={6} src={defaultImage.url} alt="Image thumb" />

              <Text fontSize={{ base: 14, md: 16 }}>
                {decodeURIComponent(defaultImage.originalName)}
              </Text>
            </HStack>
          </HStack>
        </HStack>
      )}
    </Stack>
  );
}
